module.exports = __webpack_public_path__ + "static/media/jst.caec72bf.jpg";